import { render } from "./Primary5.vue?vue&type=template&id=3aee18e8&ts=true"
import script from "./Primary5.vue?vue&type=script&lang=ts"
export * from "./Primary5.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/assets/images/avatars/Primary5.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "3aee18e8"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('3aee18e8', __exports__)) {
    api.reload('3aee18e8', __exports__)
  }
  
  module.hot.accept("./Primary5.vue?vue&type=template&id=3aee18e8&ts=true", () => {
    api.rerender('3aee18e8', render)
  })

}


export default __exports__